import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { DateTimeTooltip } from "../DateTimeTooltip";
import type { ServerDateValue } from "src/utils/dateTime";
import Pre from "@ui/pre/Pre";
import Button from "@ui/button/Button";
import Panel from "@ui/panel/Panel";
import { Box, HBox } from "@ui/box/Box";
import Signal from "badmfck-signal";
import Spacer from "@ui/spacer/Spacer";
import { ObjectViewer } from "../ObjectViewer";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { Typo } from "@ui/text/Typo";

export const S_RAW_TEXT_POPUP = new Signal<{
	title: string;
	value: string;
	summary?: { title: string; value: string; dateTime?: ServerDateValue }[];
	values?: { [key: string]: string };
} | null>("S_RAW_TEXT_POPUP");

export const RawTextPopup = () => {
	useLocale();
	const requestData = S_RAW_TEXT_POPUP.use();

	if (!requestData) return null;

	const closePopup = () => {
		S_RAW_TEXT_POPUP.invoke(null);
	};

	let value = requestData.value;
	// if (value.indexOf('==') === value.length - 2) {
	// 	try {
	// 		value = atob(value);
	// 	} catch (e) {
	// 		console.error("Error decoding base64:", e);
	// 	}
	// }

	//!TODO: height: "min-content",

	const rawContent = (
		<Pre data={value} wrap style={{ maxHeight: "calc(90vh - 150px)" }} />
	);

	const objectContent = requestData.values && <ObjectViewer data={requestData.values} />;
	const summaryContent = requestData.summary?.length ? (
		<Box
			sx={{
				display: "grid",
				gridTemplateColumns: "repeat(auto-fit, minmax(150px, max-content))",
				gap: "10px",
				padding: "0 0 12px",
			}}>
			{requestData.summary.map(item => (
				<Box
					key={item.title}
					sx={{
						border: "1px solid #00000012",
						borderRadius: "6px",
						padding: "8px 10px",
						minWidth: "150px",
					}}>
					<Typo variant="caption" color="textSecondary" block>
						{item.title}
					</Typo>
					<Typo variant="medium" sx={{ wordBreak: "break-word" }}>
						<DateTimeTooltip value={item.dateTime}>{item.value}</DateTimeTooltip>
					</Typo>
				</Box>
			))}
		</Box>
	) : null;

	return (
		<Panel
			sx={{
				width: "700px",
				maxWidth: "1200px",
				height: "90vh",
				padding: "0",
				minWidth: "500px",
				maxHeight: "90vh",
			}}
			decorator="absolute"
			label={requestData.title}
			onClose={closePopup}>
			{objectContent ? (
				<Tabs variant="modern">
					<TabItem title={msg("parsed")}>
						<>
							<Spacer size="10px" />
							{objectContent}
						</>
					</TabItem>
					<TabItem title={msg("raw_ac0562bb")}>
						<>
							<Spacer size="10px" />
							{summaryContent}
							{rawContent}
							<Spacer grow />
						</>
					</TabItem>
				</Tabs>
			) : (
				<>
					{summaryContent}
					{rawContent}
					<Spacer grow />
				</>
			)}

			<Spacer size="20px" />

			<HBox sx={{ justifyContent: "end" }}>
				<Button
					title={msg("close")}
					variant="secondary"
					onClick={() => {
						closePopup();
					}}
				/>
			</HBox>
		</Panel>
	);
};
